import React from "react";

import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, useForm } from "react-hook-form";
import * as yup from "yup";
import { PaziaButton, PaziaSwitch } from "components/atoms";
import { settingsApi } from "api";
import { useInvalidateSettings } from "api/hooks/useInvalidateSettings";
import { getApiErrorMessage, useToaster } from "utils";

export interface DocumentsV2SettingsFormProps {
  enabled: boolean;
}

export const DocumentsV2SettingsForm = ({ enabled }: DocumentsV2SettingsFormProps) => {
  const { showError, showSuccess } = useToaster();
  const invalidateSettings = useInvalidateSettings();
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: { enabled },
  });

  const onSubmit = async (values: DocumentsV2SettingsValues) => {
    try {
      await settingsApi.saveDocumentsV2(values);
      await invalidateSettings();
      methods.reset(values);
      showSuccess("Zapisano ustawienie Dokumentów 2.0");
    } catch (error) {
      showError(getApiErrorMessage(error, "Błąd podczas zapisywania ustawienia Dokumentów 2.0"));
    }
  };

  const {
    handleSubmit,
    formState: { isDirty },
  } = methods;

  return (
    <FormProvider {...methods}>
      <form className="flex flex-col gap-2" onSubmit={handleSubmit(onSubmit)}>
        <div className="flex flex-wrap items-center gap-4">
          <PaziaSwitch name="enabled" label="Dokumenty 2.0 (nowy edytor dokumentów)" />
          <PaziaButton type="success" disabled={!isDirty} title="Zapisz" />
        </div>
        <p className="text-sm text-slate-500 dark:text-slate-400">
          Włącza edytor szablonów 2.0 i generowanie dokumentów 2.0. Dokumenty 1.0 działają bez zmian.
        </p>
      </form>
    </FormProvider>
  );
};

const schema = yup
  .object({
    enabled: yup.boolean().required(),
  })
  .required();

export type DocumentsV2SettingsValues = yup.InferType<typeof schema>;
